import { Component, OnInit } from '@angular/core';

import { ActivatedRoute } from '@angular/router';
import { ProductService } from '../../services/product.service'
import { Product } from '../../entities/product.entities'
import { Location } from '@angular/common';

import { uploadService } from '../../services/uploadService';
import { Upload } from '../../entities/upload';
import * as _ from "lodash";

@Component({
  selector: 'app-edit-product',
  templateUrl: './edit-product.component.html',
  styleUrls: ['./edit-product.component.css']
})
export class EditProductComponent implements OnInit {
  idd;
  itemUpdate: Product;
  urlimg1: any;
  urlimg2: any;
  urlimg3: any;

  codeProduct;
  nameProduct;
  priceProduct;
  TypeProduct;
  weigth;
  detailProduct;

  selectedFilesProduct: any[] = [];
  currentUpload: Upload;
  currentUpload2: Upload;
  currentUpload3: Upload;

  imgpath;
  constructor(private _location: Location, private route: ActivatedRoute, private product: ProductService, public upSvc: uploadService) {
  }
  ngOnInit() {
    this.idd = this.route.snapshot.params['id'];
    this.itemUpdate = this.product.findProductIndex(this.idd)

    if (this.itemUpdate != null) {
      sessionStorage.setItem("is_reloaded", JSON.stringify(this.itemUpdate))
    } else {
      this.itemUpdate = JSON.parse(sessionStorage.getItem("is_reloaded"))
    }

    this.codeProduct = this.itemUpdate.id
    this.nameProduct = this.itemUpdate.name
    this.priceProduct = this.itemUpdate.price
    this.TypeProduct = this.itemUpdate.type
    this.weigth = this.itemUpdate.weigth
    this.detailProduct = this.itemUpdate.detailProduct
  }

  backClicked() {
    this._location.back();
  }

  detectProductFiles1(event) {
    var reader = new FileReader();
    reader.onload = (event: any) => {
      this.urlimg1 = event.target.result;
    }
    reader.readAsDataURL(event.target.files[0]);
    //this.selectedFilesProduct = event.target.files;

    let file = event.target.files.item(0)
    this.currentUpload = new Upload(file);
    this.upSvc.UpProductimage(this.currentUpload, this.idd, '1')
  }
  detectProductFiles2(event) {
    var reader = new FileReader();
    reader.onload = (event: any) => {
      this.urlimg2 = event.target.result;
    }
    reader.readAsDataURL(event.target.files[0]);
    //this.selectedFilesProduct = event.target.files;

    let file = event.target.files.item(0)
    this.currentUpload2 = new Upload(file);
    this.upSvc.UpProductimage(this.currentUpload2, this.idd, '2')
  }
  detectProductFiles3(event) {
    var reader = new FileReader();
    reader.onload = (event: any) => {
      this.urlimg3 = event.target.result;
    }
    reader.readAsDataURL(event.target.files[0]);
    //this.selectedFilesProduct = event.target.files;

    let file = event.target.files.item(0)
    this.currentUpload3 = new Upload(file);
    this.upSvc.UpProductimage(this.currentUpload3, this.idd, '3')
  }
  UpdateDataProduct() {
    let dataUpdate = {
      id: this.codeProduct,
      name: this.nameProduct,
      price: this.priceProduct,
      type: this.TypeProduct,
      weigth: this.weigth,
      detailProduct: this.detailProduct,
      photo: this.itemUpdate.photo
    }
    this.upSvc.UpdateProductDrirect(dataUpdate, this.idd)
  }
}



// WEBPACK FOOTER //
// D:/pokpak-v3/pokpak-v2/pokpak-ang/src/app/components/edit-product/edit-product.component.ts